var React = require('react');

function GiftLarge (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M21.6 7H17c.3-.2.6-.4.8-.6 1.2-1.2 1.2-3.1 0-4.2-1.1-1.1-3.1-1.1-4.2 0-.6.6-2.3 3.2-2 4.9h-.1c.2-1.7-1.4-4.2-2-4.9C8.3.9 6.3 1 5.2 2.1 4 3.2 4 5.1 5.2 6.3c.2.2.5.4.8.7H1.4C.6 7 0 7.6 0 8.4V12c0 .4.3.7.7.7h.7v8.6c0 .8.6 1.4 1.4 1.4H20c.8 0 1.4-.6 1.4-1.4v-8.6h.7c.4 0 .7-.3.7-.7V8.4c.2-.8-.4-1.4-1.2-1.4zM6.2 3.1c.3-.3.7-.5 1.1-.5.4 0 .8.2 1.1.5 1 1 1.9 3.5 1.6 3.8h-.3c-1 0-2.9-1-3.5-1.7-.6-.5-.6-1.5 0-2.1zm4.6 18.2H2.9v-8.6h7.9v8.6zm0-10H1.4V8.4h9.3v2.9zm3.8-8.2c.6-.6 1.6-.6 2.2 0 .6.6.6 1.6 0 2.2-.6.6-2.5 1.7-3.5 1.7H13c-.3-.4.7-2.9 1.6-3.9zm5.5 18.2h-7.9v-8.6h7.9v8.6zm1.5-10h-9.3V8.4h9.3v2.9z"}));
}

GiftLarge.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = GiftLarge;

GiftLarge.default = GiftLarge;
